import { Fragment } from 'react';

import { Table, VerticalSpacer } from '~/components/Elements';

import {
  Disclaimer,
  Headline,
  HeadlineSub,
  Intro,
  TableSideValue,
} from '../styles';

export const FrontDrivers = props => {
  const {
    type,
    data: { [type]: data },
  } = props;

  return (
    <Fragment>
      {['best', 'worst']
        .filter(t => data[t].results && data[t].results.length > 0)
        .map(type => (
          <Fragment key={type}>
            <Headline>{data[type].headline}</Headline>

            <Intro>{data[type].intro}</Intro>

            <Table>
              <thead>
                <tr>
                  <th>Namn</th>
                  <th>Antal starter</th>
                  <th>Spets</th>
                </tr>
              </thead>
              <tbody>
                {data[type].results.map(stat => (
                  <tr key={stat.val}>
                    <td>{stat.name}</td>
                    <td>{stat.number_of_starts}</td>
                    <td>{stat.frontrunner_percent}%</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Fragment>
        ))}
    </Fragment>
  );
};

export const TrackFrontRunners = props => {
  const {
    type,
    data: { [type]: data },
  } = props;

  const start_methods = {
    A: 'Autostart',
    V: 'Voltstart',
  };

  return (
    <Fragment>
      {data.map((track, index) => (
        <Fragment key={track.track_id}>
          {index === 0 && (
            <Fragment>
              <Headline>{track['A'].headline}</Headline>
              <Intro>{track['A'].intro}</Intro>
            </Fragment>
          )}

          {data.length > 1 && <HeadlineSub>{track.track_name}</HeadlineSub>}

          {Object.keys(start_methods)
            .filter(m => track[m].count > 0)
            .map(start_method => (
              <Fragment key={start_method}>
                <HeadlineSub>{start_methods[start_method]}</HeadlineSub>
                <Table>
                  <thead>
                    <tr>
                      <th>Spår</th>
                      <th>Spetsprocent</th>
                    </tr>
                  </thead>
                  <tbody>
                    {track[start_method].results.map(stat => (
                      <tr key={stat.track}>
                        <td>{stat.track}</td>
                        <td>
                          <strong>{stat.front_percent}%</strong>

                          {stat.front_percent_total && (
                            <TableSideValue>
                              {stat.front_percent_total}%
                            </TableSideValue>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {data.length !== index + 1 && start_method === 'V' && (
                  <VerticalSpacer margin={15} />
                )}
              </Fragment>
            ))}
        </Fragment>
      ))}

      <Disclaimer>{data[0]['A'].disclaimer}</Disclaimer>
    </Fragment>
  );
};
